import { html } from '@shared/utils/rendering/html';

import { FilterTypes } from '@shared/components/advanced-filters/filter-types';
import Chip from '@shared/components/chips';

const activeChipMap = {
    active: { text: 'Active', value: 1, css: 'bg-green' },
    inactive: { text: 'Inactive', value: 0, css: 'bg-grey' },
};

export const SystemsSearchOptions = [
    { value: 0, text: 'All' },
    { value: 1, text: 'Id' },
    { value: 2, text: 'Name' },
    { value: 3, text: 'Owner' },
];

export const SystemsFilterGroups = {
    isActive: 'isActive',
};

export const SystemsFilterDefaults = {
    selectedFilters: {}, // This is important
    defaultSearchOption: { value: 0, text: 'All' },
    filters: [
        {
            label: 'Is Active',
            identifier: SystemsFilterGroups.isActive,
            display: true,
            multiple: false,
            type: FilterTypes.STATIC_SELECT.id,
            options: [
                {
                    value: activeChipMap.active.value,
                    text: html`<${Chip}
                        css="hover ${activeChipMap.active.css}"
                        type="indicator-chip"
                        label=${{
                            text: activeChipMap.active.text,
                        }}
                    />`,
                },
                {
                    value: activeChipMap.inactive.value,
                    text: html`<${Chip}
                        css="hover ${activeChipMap.inactive.css}"
                        type="indicator-chip"
                        label=${{
                            text: activeChipMap.inactive.text,
                        }}
                    />`,
                },
            ],
        },
    ],
};
